exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pre-multi-repay .detail-dialog{width:80vw\n}\n.pre-multi-repay .detail-dialog .van-dialog__header{font-family:PingFangSC-Regular;font-size:4.53333vw;color:#000000;padding:8vw 0 4.26667vw\n}\n.pre-multi-repay .detail-dialog .van-dialog__content{padding:0 7.73333vw 4.53333vw 7.73333vw\n}\n.pre-multi-repay .detail-dialog .van-dialog__content p{font-family:PingFangSC-Light;font-size:3.73333vw;color:#333333;line-height:6.4vw\n}\n.pre-multi-repay .detail-dialog .van-dialog__confirm,.pre-multi-repay .detail-dialog .van-dialog__confirm:active{color:#4f8df7\n}\n", ""]);

// exports
